module.exports = __webpack_public_path__ + "static/media/image-17.b8cb797a.jpg";